import React from 'react';

import styles from './UnitEconomics.module.scss';

export default class UnitEconomics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // const customerPrice = this.props.customerPrice;
    const payout = this.props.payout;
    // const margin = this.props.margin;
    // const marginPercentage = this.props.marginPercentage;
    const { currencySymbol } = this.props;
    return (
      <div className={styles.root}>
        <span className={styles.title}>Unit Economics</span>
        <div style={{ marginTop: '20px' }}>
          {/* <div className={styles.child}>
            <span>Customer price</span>
            <span>
              {currencySymbol}
              {customerPrice}
            </span>
          </div> */}
          <div className={styles.child} style={{ float: 'right', width: '100px' }}>
            <span>Total Cost</span>
            <span>
              {currencySymbol}
              {payout}
            </span>
          </div>
          {/* <div className={styles.child}>
            <span>Margin({currencySymbol})</span>
            <span>
              {currencySymbol}
              {margin}
            </span>
          </div> */}
          {/* <div className={styles.child}>
            <span>Margin(%)</span>
            <span>{marginPercentage}</span>
          </div> */}
        </div>
      </div>
    );
  }
}
